import { useSelector } from 'react-redux';
import { canShowFiscalFeature, FiscalFeature } from './fiscalFeatureVisibility';

const useCanShowFiscalFeature = (feature: FiscalFeature): boolean => {
  const { company, user } = useSelector((state: any) => state.user);

  return canShowFiscalFeature(feature, {
    company,
    user
  });
};

export default useCanShowFiscalFeature;
export { FiscalFeature };
